import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './occupancyModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/Occupancies/CreateEdit';

function OccupencyCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          closeCreateEditForm={handleClose}
          occupancyEditDatas={null}
          editStatus={false}
          productId={productId}
          setNewValue={setNewValue}
        />
      </DialogContent>
    </Dialog>
  );
}

export default OccupencyCreateModal;
